import SharePage from './SharePage'

export default SharePage
// eslint-disable-next-line import/export
export * from './SharePage'
